function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("g", {
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#FFF",
  fillRule: "nonzero",
  d: "M17 0H7a7 7 0 00-7 7v10a7 7 0 007 7h10a7 7 0 007-7V7a7 7 0 00-7-7z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#FF8415",
  fillRule: "nonzero",
  d: "M17 2a5 5 0 015 5v10a5 5 0 01-5 5H7a5 5 0 01-5-5V7a5 5 0 015-5h10z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#FFF",
  d: "M17 15v2h-6v-2h6zm-8 0v2H7v-2h2zm0-4v2H7v-2h2zm8 0v2h-6v-2h6zm0-4v2h-6V7h6zM9 7v2H7V7h2z"
}));

function SvgQMaNonscoredCompletedIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24
  }, props), _ref);
}

export default SvgQMaNonscoredCompletedIcon;